const $ = require('jquery');
const _ = require("underscore");

import LookupTable from "../../../components/lookupTable/index";
import run from '../../../utilities/run';
import { handleCustomDropdownEvents } from "../../../utilities/customBootstrapDropdowns";
import EditChecker from '../../../components/EditChecker/EditChecker';
import SubmitModalFlow from "../../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT, SUCCESS_MODAL_TIMEOUT } from "../../../constants";
import { shipmentLookupFieldDropdown } from './filter/shipmentLookupFields.js';
import moment from "moment";
import render from "../../../utilities/render";
import {prepareDataToSendController, isEdit, buildExport, doAjax, pushFilterSessionCacheState, retriveCriteriaObjectByOperation, isNew, isDeleteView, isOnlyLookupDataUpdate } from "../../../utilities/filtersutil";
import { actionOptions } from "./filter/actionOptions.js";
import {isPresent} from '../../../utilities/general';

import fileUploader from '../../../components/fileuploader/index';
const statusRowHtml = require('./html/renderTemplateForIconStatus.html');
const modalHtml = require("../../../sharedHtml/modal.html");
const uploadShippingDocsModalBodyHtml = require("./html/uploadShippingDocsModalBody.html");
let actionCellDropdownTemplate = require('../../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');

let actionList = actionOptions;

const targetSelector = "#shipment-lookup";



run(targetSelector, () => {
  const dataTableComponentData = $(targetSelector).data("shipment-lookup-data");
  const packageDetailURL = $(targetSelector).data("package-detail-url");
  const portletNamespace = $(targetSelector).data("portlet-namespace");
  const orderFilterData = $(targetSelector).data("table-filter-data");
  const shouldCheckCache = $(targetSelector).data("should-check-cache");
  const criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
  const filtershipmentUrl = $(targetSelector).data("shipment-filter-url");
  const searchPageReloadUrl = $(targetSelector).data("search-page-reload");
  const userRoles = $(targetSelector).data("user-roles");
  const uploadFileUrl = $(targetSelector).data("upload-file-url");
  const downloadFileUrl = $(targetSelector).data("downloadFileUrl");
  const shipmentLookupUrl = $(targetSelector).data("get-shipment-summary-url");
  const generateExportUrl = $(targetSelector).data("export-url-shipment");
 
 

  let selectedRows = "";
  //for the views - add/save/delete
  const savedViews = $(targetSelector).data("saved-views");
  const saveViewURL = $(targetSelector).data("save-view-url");
  const deleteViewURL = $(targetSelector).data("delete-view-url");
  var disableCancel = "";

  let submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();

  let shipmentDocsFileUploadModal="";
  let targetObject = "";
  if (shouldCheckCache) {
    targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer, "like");
  }
  EditChecker.setPageClean();
  //let shipmentLookup = new LookupTable({
  let shipmentLookup = new LookupTable({
    // REQUIRED - Set a target element
    target: $("#lookup-shipment-wrapper"),
    // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
    minWidthClass: "q-min-width-sm-til-md",
    // REQUIRED - Set which data should be visible for mobile
    mobileColumns: [
        {
          data: "shpTrackingNumber",
          title: "Tracking Number",
          render: renderShipmentDetailLink
        },
        {
          data: "shpEntityId",
          title: "Order ID Number"
        },
        {
          data: "shpAttrVal2",
          title: "Sales Order Number"
        },
        {
          data: "shpAttrVal1",
          title: "Purchase Order"
        },
        {
          data: "shpCarrier",
          title: "Carrier"
        },
        {
          data: "shpShipToName",
          title: "Receiver"
        },
        {
          data: "shpShipToPostalCode",
          title: "Postal Code"
        },
        {
          data: "shpShipToCity",
          title: "City"
        },
        {
          data: "shpShipToCountry",
          title: "Country"
        },
        {
          data: "shpStatus",
          title: "Carrier Status",
          render: renderStatusRow
        }
      ],
    tableSearchInput: {
      // Not required
      // placeholder: 'Custom Search Text'
      value: (targetObject != "" ? targetObject.value[0] : "")

    },
    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
    tableSearchDropdown: {
      selected: (targetObject == "" ? "" : targetObject.key),
      columns: shipmentLookupFieldDropdown
    },
    savedViews: savedViews,
    bulkSelect: true,
    // REQUIRED - Data Table specific settings
    dataTable: {
      // use same settings you would if you were just calling a dataTable normally
      data: dataTableComponentData.content,
      columnDefs: [
        { className: "custom-class", targets: [ 1 ] }
      ],
      // Not required, just to show you can
      order: [
        [17, 'desc'],
      ],
      columns: [
        {
          data: "shpShipmentNumber",
          render: renderActionWrap,
          orderable: false,
	        class: 'dtc-action-column'
        },
        {
          data: "shpTrackingNumber",
          title: "Tracking / PRO Number",
          render: renderShipmentDetailLink,
          class: 'dtc-min-width-sm'
        },
        {
          data: "shpDocsUploaded",
          title: "Shipping Docs",
          render: renderShippingDocs,
          class: 'dtc-min-width-sm'
        },
        {
          data: "shpShipmentNumber",
          title: "Shipment Number",
          class: 'dtc-min-width-sm'
        },
        {
          data: "shpEntityId",
          title: "Order ID Number",
          class: 'dtc-min-width-sm'
        },
        {
          data: "shpBol",
          title: "BOL",
          class: 'dtc-min-width-sm'
        },
        {
          data: "shpMasterBol",
          title: "MBOL",
          class: 'dtc-min-width-sm'
        },
        {
          data: "shpAttrVal2",
          title: "Sales Order Number",
          class: 'dtc-min-width-md'
        },
        {
          data: "shpAttrVal1",
          title: "Purchase Order",
          class: 'dtc-min-width-sm'
        },
        {
          data: "shpShippedDate",
          title: "Ship Date",
          class: 'dtc-min-width-sm',
          render: timeStampToDate
        },
        {
          data: "shpCarrier",
          title: "Carrier",
          class: 'dtc-min-width-sm'
        },
        {
          data: "shpStatus",
          title: "Carrier Status",
          class: 'dtc-min-width-sm',
          render: renderStatusRow
        },
        {
          data: "shpShipToName",
          title: "Receiver",
          class: 'dtc-min-width-sm'
        },
        {
          data: "shpShipToPostalCode",
          title: "Postal Code",
          class: 'dtc-min-width-sm'
        },
        {
          data: "shpShipToCity",
          title: "City",
          class: 'dtc-min-width-sm'
        },
        {
          data: "shpShipToCountry",
          title: "Country",
          class: 'dtc-min-width-sm'
        },
        {
          data: "shpCreatedDate",
          "visible": false
        },
      ]
    },
    paginationData: dataTableComponentData.page,
    filterModal: {
      // REQUIRED: Sets title of modal
      title: "Filter Shipments",
      // REQUIRED: Sets unique part of subtitle string.
      tableType: "shipment"
    },
    onBulkSelectChange: function() {
      selectedRows = shipmentLookup.getBulkSelectedData();
        $("th.dtc-action-column").html(renderActionHeaderWrap());
      if (selectedRows.length >= 2) {
      $(".action-header-btn .base-btn").removeClass('disabled');
    }else{
        $(".action-header-btn .base-btn").addClass('disabled');
    };
  },
    onFetch: function () {
      let currentData = shipmentLookup.generateData();
      shipmentLookup.showLoadingOverlay();
      if (isOnlyLookupDataUpdate(currentData)) {
        setTimeout(() => {
          doAjax({ url: filtershipmentUrl, success: filterSuccessFun, error: errorFun, data:prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isNew(currentData)) {
        setTimeout(() => {
          doAjax({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isEdit(currentData)) {
        setTimeout(() => {
          doAjax({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isDeleteView(currentData)) {
        setTimeout(() => {
          doAjax({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      }
    }
  });

  $("#advancedSearch").on("click", function () {
    window.open(searchPageReloadUrl, "_self");
  })

 
  let table = $("#lookup-shipment-wrapper .data-table-component").DataTable();
  //Methods used for the Actions/Bulk Actions
  function renderActionCellList(list, data, row) {
    let renderedList;
    renderedList = _(list).map((item) => {
      return render(
        actionCellDropdownItemTemplate, {
          icon: item.icon,
          title: item.title,
          cls: item.cls,
          disabled: checkDisableForGivenAction(data,row,item.cls)
        }
      );
    });
    return renderedList.join('');
  }

  function checkDisableForGivenAction(data,row,actionName) {
    if(isRowLevelActionCheck(data)){
       return callBusinessLogicToDisableAction(data,row,actionName);
     }else{
         let isTrue = false;
       _(selectedRows).map((item)=>{
          if(isPresent(item) && isPresent(item.data)){
            if(callBusinessLogicToDisableAction(item.data.shpShipmentNumber,item.data,actionName)){
              if (!isTrue){
                isTrue = true;
              }
            }
          }else if(isPresent(item) && !(isPresent(item.data))){
            if(callBusinessLogicToDisableAction(item.shpShipmentNumber,item,actionName)){
              if (!isTrue){
                isTrue = true;
              }
            }
          }

         });
       return isTrue;
   }
 };

  function isRowLevelActionCheck(data) {
    return isPresent(data);
  }

  function callBusinessLogicToDisableAction(data,row,actionName) {
    if(isPresent(data) && actionName == "upload-documents"){
      if(_.contains(userRoles, "POD Admin") || _.contains(userRoles, "POD User")){
        return true;
      }else{
        return false;
      }
    }

    if(isPresent(data) && actionName == "download-documents"){
      if(row.shpDocsUploaded == 1){
        return false;
      }else{
        return true;
      }
    }

    if(actionName == "bulk-upload-documents"){
      if(checkForUniqueSelectedShipmets()){
        if(_.contains(userRoles, "POD Admin") || _.contains(userRoles, "POD User")){
          return true;
        }else{
          return false;
        }
      }{
        return true;
      }
    }

  }

  function checkForUniqueSelectedShipmets(){
    selectedRows = getAllSelectedRows();
    let selectedUniqueShipments=[];
    _(selectedRows).map((shipmentRow)=>{
      if(isPresent(shipmentRow)){
        selectedUniqueShipments.push(shipmentRow.shpShipmentNumber);
      }
    });
    if(_.uniq(selectedUniqueShipments).length >1){
      return false;
    }else{
      return true;
    }
  }

  //Methods used for the Filter and Success
  function filterSuccessFun(data) {
    let shipments = data.content;
    let page = data.page;
    shipmentLookup.setNewData(shipments);
    shipmentLookup.setPaginationData(page);
    pushFilterSessionCacheState();
    shipmentLookup.hideLoadingOverlay();
    setExportData(shipmentLookup.generateData());
  }

  function savedViewSuccess(data) {
     let shipments = data.lookupItems.content;
    let page = data.lookupItems.page;
    shipmentLookup.setNewData(shipments);
    shipmentLookup.setPaginationData(page);
    shipmentLookup.setNewSavedViewData(data.savedView, "newSavedView");
    pushFilterSessionCacheState();
    shipmentLookup.hideLoadingOverlay();
    setExportData(shipmentLookup.generateData());
  }

  function savedEditViewSuccess(data) {
    let shipments = data.lookupItems.content;
    let page = data.lookupItems.page;
    shipmentLookup.setNewData(shipments);
    shipmentLookup.setPaginationData(page);
    shipmentLookup.setNewSavedViewData(data.savedView, data.savedView.target);
    pushFilterSessionCacheState();
    shipmentLookup.hideLoadingOverlay();
    setExportData(shipmentLookup.generateData());
  }

  function delteViewScussFun(data) {
    let shipments = data.lookupItems.content;
    let page = data.lookupItems.page;
    shipmentLookup.removeSavedView(data.target);
    shipmentLookup.setNewData(shipments);
    shipmentLookup.setPaginationData(page);
    shipmentLookup.hideLoadingOverlay();
    setExportData(shipmentLookup.generateData());
  }

  function errorFun(data) {
    shipmentLookup.hideLoadingOverlay();
  }

  function renderActionWrap(data, type, row, meta) {
    let newRender;
    let statusTarget = actionList["actions"];
    newRender = render(
      actionCellDropdownTemplate, {
        list: renderActionCellList(statusTarget, data, row),
        index: meta.row
      }
    );
    return newRender;
  };

  function renderActionHeaderWrap() {
    let statusTarget = actionList['all'];
    let newRender;
    let data = "";
    let row = "";
    newRender = render(
    actionHeaderDropdownTemplate, {
      list: renderActionCellList(statusTarget,data,row)
    }
  );
  return newRender;
};

$('body').on('click', '.upload-documents', function(e) {
  e.preventDefault();
  if(shallAllowClick(this)){
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
    let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    let row = $(".data-table-component").dataTable().api().row(parent);
    //let row = table.row(parent);
    generateSharedModal([row.data()]);
  }
});

$('body').on('click', '.bulk-upload-documents', function(e) {
  e.preventDefault();
  if(shallAllowClick(this)){
    generateSharedModal(getAllSelectedRows());
  }
});

function getAllSelectedRows(){
  let shipmentRows = new Array();
  _(selectedRows).map((shipmentRow)=>{
    if(isPresent(shipmentRow.data)){
      shipmentRows.push(shipmentRow.data);
    }else if(isPresent(shipmentRow) && !(isPresent(shipmentRow.data))){
      shipmentRows.push(shipmentRow);
    }
   });
  return shipmentRows;
}

$('body').on('click', '.download-documents', function(e) {
  e.preventDefault();
  if(shallAllowClick(this)){
   	// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
    let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    let row = $(".data-table-component").dataTable().api().row(parent);
    //let row = table.row(parent);
    downloadFiles([row.data()]);

  }
});

$('body').on('click', '.bulk-download-documents', function(e) {
  e.preventDefault();
  if(shallAllowClick(this)){
    downloadFiles(getAllSelectedRows());
  }
});

function shallAllowClick(currentObj){
  return 	!($(currentObj).hasClass("disabled"));
}

  //Method to pouplate the tracking number as link
  function renderShipmentDetailLink(data, type, row) {
    let linkHTML;
    if (data == 'Not Available' && row.shpFreight == 0){
      linkHTML = `<div class="q-marg-all-xs-at-md">{%- data %}</div>`;
    }else{
      linkHTML = `<div class="q-marg-all-xs-at-md"><a href={%= shipmentDetailURL %}&shpTrackingNumber={%- shpTrackingId %}&shpShipmentNumber={%- shipmentNumber %}&frightFlag={%- frightFlag %}&shipmentBol={%- shipmentBol %}&facilityNo={%- facilityNo %}&wmOrderNo={%- wmOrderNo %} class='details-control anchor-text'>{%- data %}</a></div>`;
    }

    let shipmentTrackingID = row.shpTrackingNumber;
    if(shipmentTrackingID == 'Not Available'){
      shipmentTrackingID = 'NotAvaliable';
    }

    let shipmentInfoLink = render(
      
      linkHTML, {
        data: data,
        row: row,
        shipmentDetailURL: packageDetailURL,
        shpTrackingId: shipmentTrackingID,
        shipmentNumber: row.shpShipmentNumber,
        frightFlag : row.shpFreight,
        shipmentBol : row.shpBol,
        facilityNo : row.shpMerchantBuId,
        wmOrderNo : row.shpEntityId
      }
    );
    return shipmentInfoLink;
  }

  function timeStampToDate(data, type, row) {
    return moment(row.shpShippedDate).format("YYYY/MM/DD");
  }

  //Method to pouplate the Status with a Pill Fill
  function renderStatusPill(data, type, row) {
    let renderStatus;
    let statusHTML;
    if (data == "Active") {
      statusHTML = "<div class='q-pill q-pill-blue q-pill-detail'>{%-data%}</div>";
    } else {
      statusHTML = "<div class='q-pill q-pill-blue-border q-pill-detail'>{%-data%}</div>";
    }
    renderStatus = render(
      statusHTML, {
        data: data
      }
    );
    return renderStatus;
  }

  //to call new html for the last column/country
  function renderStatusRow(data, type, row) {
    return render(statusRowHtml, {
      icon: row.icon,
      ordStatus: row.shpStatus,
      statusColor: row.statusColor
    })
  }

  function renderShippingDocs(data, type, row){
    if(data!=null && data==1){
      return render("<center><span class='q-pretty-pill-tag q-ppt-blue-border q-ppt-pad-md'>Yes</span></center>");
    }else{
      return render("<center><span class='q-pretty-pill-tag q-ppt-white q-ppt-pad-md'>No</span></center>");
    }
  }

  function generateSharedModal(rowData){
    shipmentDocsFileUploadModal = $(render(
      modalHtml,
      {
        title: ' Upload Shipping Documents',
        leftAlignTitle: true,
        body: uploadShippingDocsModalBodyHtml,
        modalDialogClass: "q-modal-dialog-800",
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: `
        <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>
        <a  href="#" class="base-btn purple-btn custom-submit-btn upload-selected-files disabled">Upload Selected</a>
        `
      }
      ));
      $("body").append(shipmentDocsFileUploadModal);

      let shipDocsFileUploader = new fileUploader({
        target: '.ship-docs-file-uploader-body',
        accept: ['.xls','.xlsx','.doc','.docx','.pdf','.tiff','.tif','.jpg','.jpeg','.gif','.txt','.csv'],
        multiple: true,
        maxFileSize: 10,
        afterValidSelection : function(){
          shipmentDocsFileUploadModal.find(".upload-selected-files").removeClass("disabled");
        },
        afterInvalidSelection : function(){
          shipmentDocsFileUploadModal.find(".upload-selected-files").addClass("disabled");
        }
      });

    shipDocsFileUploader.init();
    shipmentDocsFileUploadModal.modal("show");

    if(shallAllowClick(this)){
      $(".upload-selected-files").on('click',()=>{
        submitModalFlow.showLoadingModal();
        sendFiles(shipDocsFileUploader.getFiles(), rowData);
      });
    }
    shipmentDocsFileUploadModal.on('hidden.bs.modal', function (e) {
      shipmentDocsFileUploadModal.remove();
    });

  }

  function sendFiles(fileList, rowData){
     shipmentDocsFileUploadModal.modal("hide");
     let formData = new FormData();
     fileList.forEach(file=>{formData.append("files[]", file)});
     formData.append("shpShipmentRow", JSON.stringify(rowData));
     let uploadUri = `${uploadFileUrl}&shpShipmentNumber=${_.uniq(rowData)}`;
    $.ajax({
      url: uploadUri,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      cache: false,
      success: sendFileSuccess,
      error: sendFileError
    });
  }

  function downloadFiles(rowData){
    let downloadFileUri = `${downloadFileUrl}&shpShipmentNumber=${rowData}`;
    let formData = new FormData();
    formData.append("shpShipmentRow", JSON.stringify(rowData));
    submitModalFlow.showLoadingModal();
    $.ajax({
      url: downloadFileUri,
      type: 'POST',
      data: formData,
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      cache: false,
      success: downloadFileSuccess,
      error: downloadFileError
    });
  }

  function sendFileSuccess(resp){
      if($.trim(resp)=="true"){
        shipmentDocsFileUploadModal.modal("hide");
        submitModalFlow.showSuccessModal();
        setTimeout(function() {
          location.href = shipmentLookupUrl;
        }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
      }else{
        sendFileError();
      }

  }

  function sendFileError(){
    submitModalFlow.hideAllModals();
    shipmentDocsFileUploadModal.find(".upload-error").show();
  }

  function downloadFileSuccess(data){
    if(isPresent(data)){
      $.each(JSON.parse(data), function (key, value) {
        if(value.contentType=="atd"){
          value.contentType="txt";
        }
        downloadFile(value.contentType, value.fileName, value.content);
      });
    }else{
      setTimeout(function() {
        submitModalFlow.hideAllModals();
        submitModalFlow.showFailureModal();
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    }

  }

  function downloadFileError(){
    submitModalFlow.showFailureModal();
        setTimeout(function() {
          submitModalFlow.hideAllModals();
          submitModalFlow.showFailureModal();
        }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
  }

  function downloadFile(mimeType, fileName, data){
    var a = document.createElement('a');
    if (window.URL && window.Blob && ('download' in a) && window.atob) {
      // Do it the HTML5 compliant way
      var blob = base64ToBlob(data, mimeType);
      var url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    }
    submitModalFlow.hideAllModals();
  }

  function base64ToBlob(base64, mimetype, slicesize) {
    if (!window.atob || !window.Uint8Array) {
        // The current browser doesn't have the atob function. Cannot continue
        return null;
    }
    mimetype = "application/"+mimetype || '';
    slicesize = slicesize || 512;
    var bytechars = atob(base64);
    var bytearrays = [];
    for (var offset = 0; offset < bytechars.length; offset += slicesize) {
        var slice = bytechars.slice(offset, offset + slicesize);
        var bytenums = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            bytenums[i] = slice.charCodeAt(i);
        }
        var bytearray = new Uint8Array(bytenums);
        bytearrays[bytearrays.length] = bytearray;
    }
    return new Blob(bytearrays, {type: mimetype});
};

shipmentLookup.init();


  // Export component integration.
  let exportUrl = "";

  function setExportData(currentData) {
    exportUrl = exportURl(generateExportUrl, currentData);
  }

  setExportData(shipmentLookup.generateData());

  $("#exportData").on("click", function () {
    window.open(exportUrl, "_self");
   })

  function exportURl(resourceURL,currentData,portletNamespace) {
    let url = "";
		let startDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'startDate');
		let endDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'endDate'); 
		let fixedRangeDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'fixedRange'); 
		let revisedSearchCriteria =  alterSearchCriteriForController(currentData["searchCriteria"])
		let orderBy =  currentData["orderBy"] == 'ordStatus' ? "ordStatusCode" : currentData["orderBy"]
		let searchCriteria =   _.toArray(revisedSearchCriteria).length > 0 ? JSON.stringify(_.toArray(revisedSearchCriteria)) : _.toArray(revisedSearchCriteria);

		
		searchCriteria = encodeURIComponent(searchCriteria);

		portletNamespace = isPresent(portletNamespace) ? portletNamespace : "";
		//url = resourceURL+"&endDate="+endDate+"&startDate="+startDate+"&fixedRange="+fixedRangeDate+"&page=0"+"&size=1000"+"&orderBy="+orderBy+"&orderByType="+currentData["sortType"]+"&searchCriteria="+searchCriteria;
    url=resourceURL+[`&${portletNamespace}endDate=`]+endDate+[`&${portletNamespace}startDate=`]+startDate+[`&${portletNamespace}fixedRange=`]+fixedRangeDate+[`&${portletNamespace}page=0&${portletNamespace}size=1000&${portletNamespace}orderBy`]+orderBy+[`&${portletNamespace}orderByType=`]+currentData["sortType"]+[`&${portletNamespace}searchCriteria=`]+searchCriteria;
    return url;
  }
  
  function readSpecificKeyFromSearchCriteria(searchCriteria,key){
    let value = "";
    $.each(searchCriteria, function(i, item) {
      if(item.key == key)
      {
        value =  item.value[0];	
      }
    });
    return value;
  }

  function alterSearchCriteriForController(searchCriteria){
    // This omit is require cause, lookup component is adding below information in searchCriteria which was not the case earlier,
    // so instead change controller side code beeter to send what contrller is expecting.
    let revisedSearchCriteria =   _.omit(searchCriteria, function(value, key, object) {
      return (value.key == 'fixedRange' ||  value.key == 'startDate' ||value.key == 'endDate' ); 
    });
    return  _.toArray(revisedSearchCriteria);
  }


  $("th.dtc-action-column").html(renderActionHeaderWrap());
  handleCustomDropdownEvents();
  

});



// WEBPACK FOOTER //
// ./src/pages/proofOfDelivery/podShipmentSummary/shipmentLookup.js